/**
 * @module Product 
 *  Apis must need auth details to trigger url - NormalApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApi from '@/Components/Controllers/NormalApis';


export default {

    /**
     * Fetch data by id
     */
    fetchById(id) {
      // const url = `${Env.productUrl}/api/v1/locationProducts/${id}?include_aromas=1&status=1&include_cannabis_attributes=1&include_colours=1&include_flavours=1&include_images=1&include_moods=1&include_terpenes=1&include_thc_cbd=1&include_variants=1&include_brands=1&include_location_product_category=1`; 
        const url = `${Env.productUrl}/api/v1/locationProducts/${id}?status=1&available=all&include_cannabis_attributes=1&include_images=1&include_terpenes=1&include_aromas=1&include_thc_cbd=1&include_variants=1&include_brands=1&include_location_product_category=1`;
        return NormalApi.getApi(url, {
                "app-id": Env.productAppId,
                "app-secret": Env.productAppSecret
            })
            .then(res => res)
            .catch(err => err);
    },

    /**
     * Fetch data id id
     */
    getProductVaraintByIds(ids) {
      const url = `${Env.productUrl}/api/v1/locationProducts/getProductVaraintByIds`;
      return NormalApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      },{
        "location_product_varaint_id" : ids
      })
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Fetch recommend products
     */
    fetchRecommendProducts({ location_category_id }) {
      const url = `${Env.productUrl}/api/v1/locationCategories/getLocationCategoryRecommendations?include_brands=1&include_products=1&include_variants=1&include_thc_cbd=1&include_cannabis_attributes=1&include_location_product_category=1`;
      return NormalApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      },{
        location_category_id
      })
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Fetch recommend products
     */
     fetchRecommendProductsByLocationProductIds({ location_products_ids }) {
       const url = `${Env.productUrl}/api/v1/locationCategories/getRecommendationsByProducts?include_brands=1&include_products=1&include_variants=1&include_thc_cbd=1&include_cannabis_attributes=1&include_location_product_category=1`;
      return NormalApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      },{
        location_products_ids
      })
      .then(res => res)
      .catch(err => err);
    },

}